import React from 'react'

export default () => (<p>Dashboard</p>)



// WEBPACK FOOTER //
// ./src/pages/Dashboard/index.js